export default __webpack_public_path__ + "static/media/04AW1JUL66.32afcdeb.jpg";